import Vue from 'vue'
import Router from 'vue-router'



const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err);
};
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

Vue.use(Router)



const routes =[
      {
      path: '/',
      redirect:'/home'
      },
      {
        path: '/home',
        name: 'home',
        component: () => import('../views/home.vue'),
       },
       {
         path: "/order",
         name:"order",
        component: () => import('../views/order.vue'),
       },

       {
        path: "/Declaration",
        name:"Declaration",
       component: () => import('../views/Declaration.vue'),
       },
       {
        path: "/complete",
        name:"complete",
       component: () => import('../views/complete.vue'),
       },
       {
        path: "/Waybill",
        name:" Waybill",
       component: () => import('../views/Waybill.vue'),
       },
       {
        path: "/problem",
        name:" problem",
       component: () => import('../views/problem.vue'),
       },
       {
        path: "/Freight",
        name:"Freight",
       component: () => import('../views/Freight.vue'),
       },
       {
        path: "/terms",
        name:"terms",
       component: () => import('../views/terms.vue'),
       },
       {
        path: "/Sending",
        name:"Sending",
       component: () => import('../views/Sending.vue'),
       },
       {
        path: "/payment",
        name:"payment",
       component: () => import('../views/payment.vue'),
       },









  ]
  const router = new Router({
    mode: 'history',
    routes
  })
  // 使用全局前置守卫
router.beforeEach((to, from, next) => {
  if (to.path !== from.path) {
    // 路由跳转前，将滚动位置设置到顶部
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  }
  next();
});

  export default router





// WEBPACK FOOTER //
// ./src/router/index.js